/******************************************************************************
 mlib-components
 Library for UI components widely used in LB apps.
 (c) Longboard Architectural Products
 ******************************************************************************/
import React__default from 'react';
import useStickyState from '../../hooks/StickyState/useStickyState.js';
import RunConfig from '../../utils/RunConfig/runconfig.js';

var PageContext = React__default.createContext({
    title: '',
    currentUrl: '',
    language: '',
    warehouse: '',
    playing: false,
    updateCurrentUrl: function (currentUrl) {
    },
    updateTitle: function (title) {
    },
    updateLanguage: function (language) {
    },
    updateWarehouse: function (title) {
    },
    play: function () {
    },
    pause: function () {
    },
});
var PageContextProvider = function (props) {
    var _a = useStickyState('', "".concat(RunConfig === null || RunConfig === void 0 ? void 0 : RunConfig.clientId, "Title")), title = _a[0], setTitle = _a[1];
    var _b = useStickyState('', "".concat(RunConfig === null || RunConfig === void 0 ? void 0 : RunConfig.clientId, "CurrentUrl")), currentUrl = _b[0], setCurrentUrl = _b[1];
    var _c = useStickyState("en-us", "language"), language = _c[0], setLanguage = _c[1];
    var _d = useStickyState("ABBOTSFORD", "warehouseState"), warehouse = _d[0], setWarehouse = _d[1];
    var _e = React__default.useState(true), playing = _e[0], setPlaying = _e[1];
    var updateTitleHandler = React__default.useCallback(function (title) {
        setTitle(title);
    }, []);
    var updateCurrentUrlHandler = React__default.useCallback(function (currentUrl) {
        setCurrentUrl(currentUrl);
    }, []);
    var updateWarehouseHandler = React__default.useCallback(function (warehouse) {
        setWarehouse(warehouse);
        localStorage.setItem('warehouse', warehouse);
    }, []);
    var updateLanguageHandler = React__default.useCallback(function (language) {
        setLanguage(language);
    }, []);
    var playHandler = React__default.useCallback(function () {
        setPlaying(true);
        localStorage.setItem('playing', playing.toString());
    }, []);
    var pauseHandler = React__default.useCallback(function () {
        setPlaying(false);
        localStorage.setItem('playing', playing.toString());
    }, []);
    React__default.useEffect(function () {
        localStorage.setItem('playing', playing.toString());
        localStorage.setItem('warehouse', warehouse);
    }, []);
    var contextValue = {
        title: title,
        currentUrl: currentUrl,
        language: language,
        warehouse: warehouse,
        playing: playing,
        updateTitle: updateTitleHandler,
        updateCurrentUrl: updateCurrentUrlHandler,
        updateLanguage: updateLanguageHandler,
        updateWarehouse: updateWarehouseHandler,
        play: playHandler,
        pause: pauseHandler,
    };
    return (React__default.createElement(PageContext.Provider, { value: contextValue }, props.children));
};
var PageContext$1 = PageContext;

export { PageContextProvider, PageContext$1 as default };
